import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Users, Inbox, Package, Settings as SetIcon, LogOut } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <div className="p-16 text-center text-white/50">Loading...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  const items = [
    { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
    { to: "/admin/leads", icon: Inbox, label: "Leads" },
    { to: "/admin/customers", icon: Users, label: "Customers" },
    { to: "/admin/products", icon: Package, label: "Loan Products" },
    { to: "/admin/settings", icon: SetIcon, label: "Settings" },
  ];
  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#FAFAF7] text-[#0B0B0B]">
      <div className="flex">
        <aside className="w-64 min-h-screen bg-[#0B0B0B] text-white p-6 flex flex-col sticky top-0 h-screen">
          <div className="flex items-center gap-3 mb-10">
            <img src="/assets/sk-logo.jpeg" className="w-11 h-11 rounded-full ring-1 ring-[#D4AF37]/40"/>
            <div>
              <div className="font-display text-lg">SK Group</div>
              <div className="text-[10px] tracking-[0.28em] text-[#D4AF37] uppercase">Admin</div>
            </div>
          </div>
          <nav className="flex-1 space-y-1">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g,"-")}`}
                className={({isActive}) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-colors ${isActive?"bg-[#D4AF37] text-black font-medium":"text-white/70 hover:bg-white/5"}`}
              >
                <it.icon size={16}/> {it.label}
              </NavLink>
            ))}
          </nav>
          <button data-testid="admin-logout" onClick={() => { logout(); nav("/admin/login"); }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-white/70 hover:bg-white/5">
            <LogOut size={16}/> Logout
          </button>
        </aside>
        <main className="flex-1 min-w-0">
          <Outlet/>
        </main>
      </div>
    </div>
  );
}
